import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-a75b6574"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-content__links row col-lg-8 col-md-8 col-sm-10 col-xs-12 justify-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    class: "footer-content__link",
    href: "/RISKPOOLS PRIVACY POLICY.pdf"
  }, " Privacy Policy "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    class: "footer-content__link",
    href: "/Business Proposal Doc.pdf"
  }, " Business Proposal Doc ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-content__company-label col-lg-2 col-md-2 col-xs-12 text-right" }, " (с) Riskpools 2024 ", -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterContent',
  setup(__props) {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "container" }, [
      _createElementVNode("div", { class: "footer-content__main row justify-between" }, [
        _createElementVNode("div", { class: "col-lg-2 col-md-2 sm-2" }, [
          _createElementVNode("div", { class: "footer-content__logo" }, [
            _createElementVNode("img", {
              onClick: scrollToTop,
              src: _imports_0,
              alt: "footer-content logo"
            })
          ])
        ]),
        _hoisted_2,
        _hoisted_3
      ])
    ])
  ]))
}
}

})